import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    A_VocTyp: "",
    VocName: "",
    A_VocNo: "",
    A_PostDt: new Date(), 
    A_Party: "",
    PartyName: "",
    A_Br: "",
    BrName: "",
    A_Loc: "",
    LocName: "",
    TrnTyp: "",
    TrnTypName: "",
    Status: "ENTER",
    
  },
  DetailHead:{
    DispatchDate1:new Date(), 
    Version: "0",
    Status: "ENTER",
  },
  SummaryObj: {
    Branch: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    Status: "P",
    Document:""
  },
};

const SliceBatchOut = createSlice({
  name: "SliceBatchOut",
  initialState: { value: initialState },

  reducers: {
    Set_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },

    Set_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    Slice_BatchOut_Init: (state) => {
      state.value = initialState;
    },

    Set_HeadObj_DetailHead: (state, action) => {
      state.value.DetailHead.DispatchDate1 = action.payload.DispatchDate1;
      state.value.DetailHead.Version = action.payload.Version; 
    },
    Set_HeadObj_DetailHead_Update: (state, action) => {
      state.value.DetailHead  = action.payload;
     },
    Set_HeadObj_DetailHead_Varsion: (state, action) => { 
      state.value.DetailHead.Version = action.payload.Version; 
    },
    Set_HeadObj_DetailHead_Date: (state, action) => {
      state.value.DetailHead.DispatchDate1 = action.payload.DispatchDate1; 
    },
    Set_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    
  },
});

export const {
  Set_HeadObj,
  Set_SummaryObj,
  Set_HeadObject_A_DocStat, 
  Slice_BatchOut_Init,
  Set_HeadObj_Init,
  Set_HeadObj_DetailHead,
  Set_HeadObj_DetailHead_Varsion,
  Set_HeadObj_DetailHead_Date,
  Set_HeadObj_DetailHead_Update
} = SliceBatchOut.actions;
export default SliceBatchOut.reducer;
